import Agent from 'infrastructure/agent';
import { saveFile } from 'utils/app.util';

export const searchWellbores = (filter) =>
  Agent.get('/search/wellbore', filter);

export const getWellboreStatuses = () =>
  Agent.get('/search/filter/valueset/wellborestatus');

export const getWellboreTrajectory = (fieldId, wellId) =>
  Agent.get(`/field/${fieldId}/wellbore/${wellId}/trajectory`);

export const getWellbore = (fieldId, wellId) =>
  Agent.get(`/field/${fieldId}/wellbore/${wellId}`);

export const getSchematicData = (wellboreId) =>
  Agent.get(`/wellbore/${wellboreId}/schematic`);

export const createNewSchematicVersion = (wellboreId, data) =>
  Agent.post(`/wellbore/${wellboreId}/schematic`, data);

export const getWellboreEvents = (fieldId, wellId) =>
  Agent.get(`/field/${fieldId}/wellbore/${wellId}/events`);

export const uploadWellboreTrajectory = (fieldId, wellId, file, meta = {}) =>
  Agent.file.post(
    `/field/${fieldId}/wellbore/${wellId}/trajectory`,
    file,
    meta,
  );

export const getWellboreTrajectoryPreview = (
  fieldId,
  wellboreId,
  file,
  meta = {},
) =>
  Agent.file.post(
    `/field/${fieldId}/wellbore/${wellboreId}/trajectory/preview`,
    file,
    meta,
  );

export const downloadTrajectoryTemplateTxt = () =>
  Agent.file
    .get('/wellbore/trajectory/template/txt')
    .then(([file, filename]) => saveFile(file, filename));

export const downloadTrajectoryTemplateCsv = () =>
  Agent.file
    .get('/wellbore/trajectory/template/csv')
    .then(([file, filename]) => saveFile(file, filename));

export const downloadTrajectorySurveyTxt = (wellboreId) =>
  Agent.file
    .get(`/wellbore/${wellboreId}/trajectory/survey/txt`)
    .then(([file, filename]) => saveFile(file, filename));

export const downloadTrajectorySurveyCsv = (wellboreId) =>
  Agent.file
    .get(`/wellbore/${wellboreId}/trajectory/survey/csv`)
    .then(([file, filename]) => saveFile(file, filename));

export const getWellcomTrajectorySurvey = (wellId) =>
  Agent.get(`/wellbore/${wellId}/trajectory/wellcom`);

export const getWellboreRevisionWithElementsFromWellcom = (fieldId, wellId) =>
  Agent.get(`/field/${fieldId}/wellbore/${wellId}/elements/wellcom`);

export const getWellboreRevisionWithElements = (fieldId, wellId) =>
  Agent.get(`/field/${fieldId}/wellbore/${wellId}/elements`);

export const searchAperioWellbores = (filter) =>
  Agent.get('/search/wellbore/aperio', filter);

export const loadAllElementsList = () =>
  Agent.get('/wellbore/schematic/elements');

export const addCorrosionLog = () =>
  Agent.post('/IntegrityManagementCorrosion/upload');

export const loadCorrosionLogsByWell = (wellId) =>
  Agent.get(`/IntegrityManagementCorrosion/get-by-well-id/${wellId}`);

export const deleteCorrosionLog = (fileId) =>
  Agent.delete(`/IntegrityManagementCorrosion/delete/${fileId}`);

export const loadCorrosionLogFile = (fileId) =>
  Agent.file
    .get(`/IntegrityManagementCorrosion/download/${fileId}`)
    .then(([file, fileName]) => saveFile(file, fileName));

export const loadCorrosionLogTemplate = () =>
  Agent.file
    .get('/IntegrityManagementCorrosion/downloadTemplate')
    .then(([file, filename]) => saveFile(file, filename));

export const loadServiceProviders = () =>
  Agent.get('/IntegrityManagementProviderService');

export const loadCorrosionMeasureTools = () =>
  Agent.get('/IntegrityManagementCorrosionMeasureTool');

export const createServiceProviders = (serviceProvider) =>
  Agent.post('/IntegrityManagementProviderService', serviceProvider);

export const createCorrosionMeasureTool = (tool) =>
  Agent.post('/IntegrityManagementCorrosionMeasureTool', tool);

export const createNewCorrosionLog = (file, data) =>
  Agent.file.post('/IntegrityManagementCorrosion/upload', file, data);

const wellboreService = {
  getWellbore,
  getSchematicData,
  createNewSchematicVersion,
  searchWellbores,
  getWellboreEvents,
  getWellboreStatuses,
  getWellboreTrajectory,
  uploadWellboreTrajectory,
  getWellcomTrajectorySurvey,
  downloadTrajectorySurveyTxt,
  downloadTrajectorySurveyCsv,
  getWellboreTrajectoryPreview,
  downloadTrajectoryTemplateTxt,
  downloadTrajectoryTemplateCsv,
  getWellboreRevisionWithElements,
  getWellboreRevisionWithElementsFromWellcom,
  searchAperioWellbores,
  loadAllElementsList,
  loadCorrosionLogTemplate,
  addCorrosionLog,
  loadCorrosionLogsByWell,
  deleteCorrosionLog,
  loadCorrosionLogFile,
  loadServiceProviders,
  loadCorrosionMeasureTools,
  createServiceProviders,
  createCorrosionMeasureTool,
  createNewCorrosionLog,
};

export default wellboreService;
